import clsx from 'clsx';
import React from 'react';
import ContentLoader from 'react-content-loader';
import ClientOnly from '@/components/ClientOnly';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const SharedWidgetSelectLoader = _ref => {
  let {
    isLarge,
    isMedium
  } = _ref;
  return /*#__PURE__*/_jsxs(ClientOnly, {
    children: [/*#__PURE__*/_jsxs("aside", {
      className: styles.sidebar,
      children: [/*#__PURE__*/_jsx("h6", {
        className: isLarge ? '' : '-mb-xsmall',
        children: "Filters:"
      }), /*#__PURE__*/_jsx(SidebarLoader, {
        isLarge: isLarge
      })]
    }), /*#__PURE__*/_jsxs("ul", {
      className: clsx(styles.list, isMedium || isLarge ? styles['list--grid'] : ''),
      children: [/*#__PURE__*/_jsx("li", {
        className: styles.item,
        children: /*#__PURE__*/_jsx(ListLoader, {})
      }), /*#__PURE__*/_jsx("li", {
        className: styles.item,
        children: /*#__PURE__*/_jsx(ListLoader, {})
      }), /*#__PURE__*/_jsx("li", {
        className: styles.item,
        children: /*#__PURE__*/_jsx(ListLoader, {})
      }), /*#__PURE__*/_jsx("li", {
        className: styles.item,
        children: /*#__PURE__*/_jsx(ListLoader, {})
      })]
    })]
  });
};

const SidebarLoader = _ref2 => {
  let {
    isLarge
  } = _ref2;
  return isLarge ? /*#__PURE__*/_jsxs(ContentLoader, {
    height: 215,
    style: {
      width: '100%',
      maxWidth: '275px'
    },
    viewBox: "0 0 275 215",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "9",
      width: "120",
      height: "22"
    }), /*#__PURE__*/_jsx("rect", {
      x: "185",
      y: "9",
      width: "90",
      height: "22"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "43",
      width: "275",
      height: "1"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "55",
      width: "155",
      height: "22"
    }), /*#__PURE__*/_jsx("rect", {
      x: "185",
      y: "55",
      width: "90",
      height: "22"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "89",
      width: "275",
      height: "1"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "101",
      width: "155",
      height: "22"
    }), /*#__PURE__*/_jsx("rect", {
      x: "185",
      y: "101",
      width: "90",
      height: "22"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "135",
      width: "275",
      height: "1"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "147",
      width: "120",
      height: "22"
    }), /*#__PURE__*/_jsx("rect", {
      x: "185",
      y: "147",
      width: "90",
      height: "22"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "181",
      width: "275",
      height: "1"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "193",
      width: "145",
      height: "22"
    }), /*#__PURE__*/_jsx("rect", {
      x: "185",
      y: "193",
      width: "90",
      height: "22"
    })]
  }) : /*#__PURE__*/_jsxs(ContentLoader, {
    height: 34,
    className: '-mb-small',
    viewBox: "0 0 250 34",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "0",
      width: "40",
      height: "34"
    }), /*#__PURE__*/_jsx("rect", {
      x: "50",
      y: "0",
      width: "107",
      height: "34"
    }), /*#__PURE__*/_jsx("rect", {
      x: "167",
      y: "0",
      width: "90",
      height: "34"
    })]
  });
};

const ListLoader = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("aside", {
    className: styles.item__preview,
    children: /*#__PURE__*/_jsx(ImageLoader, {})
  }), /*#__PURE__*/_jsx("footer", {
    className: styles.item__footer,
    children: /*#__PURE__*/_jsxs(ContentLoader, {
      height: 55,
      style: {
        width: '100%',
        height: '55px'
      },
      viewBox: "0 0 353 55",
      children: [/*#__PURE__*/_jsx("rect", {
        x: "0",
        y: "0",
        width: "225",
        height: "25"
      }), /*#__PURE__*/_jsx("rect", {
        x: "0",
        y: "29",
        width: "62",
        height: "26"
      }), /*#__PURE__*/_jsx("rect", {
        x: "68",
        y: "29",
        width: "48",
        height: "26"
      })]
    })
  })]
});

export const ImageLoader = () => /*#__PURE__*/_jsx(ContentLoader, {
  height: 188,
  style: {
    width: '100%',
    height: 'auto'
  },
  viewBox: "0 0 313 188",
  children: /*#__PURE__*/_jsx("rect", {
    x: "0",
    y: "0",
    width: "313",
    height: "188"
  })
});
export default SharedWidgetSelectLoader;